"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIAboutMeResponseSchema = exports.APIAboutMeRequestSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
// ===== BASE SCHEMA =====
const APIAboutMeRequestBaseSchema = zod_1.z.object({
    gender: zod_1.z.enum(enums_1.genderEnum).nullish(),
    skinPatterns: zod_1.z.array(zod_1.z.enum(enums_1.skinPatternsEnum)).nullish(),
    skinSensitivity: zod_1.z.enum(enums_1.skinSensitivityEnum).nullish(),
    pregnancy: zod_1.z.enum(enums_1.pregnancyEnum).nullish(),
    pregnancyDueDate: zod_1.z.string().nullish(),
    timeOutdoors: zod_1.z.enum(enums_1.outdoorsEnum).nullish(),
    makeup: zod_1.z.enum(enums_1.makeupEnum).nullish(),
});
// ===== REQUEST SCHEMA =====
// Note: pregnancyDueDate is optional even when pregnancy='yes' (simplified Day 3 flow)
exports.APIAboutMeRequestSchema = APIAboutMeRequestBaseSchema;
// ===== RESPONSE SCHEMA =====
exports.APIAboutMeResponseSchema = zod_1.z.object({
    gender: zod_1.z.enum(enums_1.genderEnum).nullable(),
    skinPatterns: zod_1.z.array(zod_1.z.enum(enums_1.skinPatternsEnum)).nullable(),
    skinSensitivity: zod_1.z.enum(enums_1.skinSensitivityEnum).nullable(),
    pregnancy: zod_1.z.enum(enums_1.pregnancyEnum).nullable(),
    pregnancyDueDate: zod_1.z.string().nullable(),
    timeOutdoors: zod_1.z.enum(enums_1.outdoorsEnum).nullable(),
    makeup: zod_1.z.enum(enums_1.makeupEnum).nullable(),
});
//# sourceMappingURL=about_me.js.map